// extracted by mini-css-extract-plugin
export default {"KeysList":"KeysList_KeysList__gVJY7","actions":"KeysList_actions__6osf6"};